import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class RelationshipWithPolicyholder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getRelationshipWithPolicyholder`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data, isDataLoaded: true });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup>
        <Col componentClass={ControlLabel} sm={5}>
          Relationship with Policyholder *
        </Col>
        <Col sm={7}>
          {this.state.isDataLoaded ?
            <div className="ebaoUtil__Container">
              <select
               className="custom-select"
               value={this.props.relationshipWithPolicyholder}
               onChange={this.props.handleChangeRelationshipWithPolicyholder}
               name="relationshipWithPolicyholder"
               required
             >
               <option value="">Please Select</option>
               {this.state.option.map((obj, index) => {
                 const counter = index;
                 return (
                   <option
                     value={obj.code}
                     key={counter}
                   >{obj.name}</option>
                 );
               })}
             </select>
           </div> : <div>Loading</div>}
        </Col>
      </FormGroup>
    )
  }
}

RelationshipWithPolicyholder.propTypes = {
  handleChangeRelationshipWithPolicyholder: PropTypes.func,
  relationshipWithPolicyholder: PropTypes.string
};

export default RelationshipWithPolicyholder;



// WEBPACK FOOTER //
// ./src/app/components/relationshipWithPolicyholder/RelationshipWithPolicyholder.js